<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-s gap-10">
        <button
          type="button"
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="ac-header">
          Note
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div>
        <div class="sac__font-14 semi-bold margin-top-16">
          {{ selectedNote.userName }} - {{ formatNoteDate(selectedNote.noteDate) }} at
          {{ formatTime(selectedNote.noteDate) }}
        </div>
        <div class="note-container">
          {{ selectedNote.note }}
        </div>
      </div>
      <div class="note-snippet-container">
        {{ selectedNote.actionNote }}
      </div>
    </div>
  </div>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import formatterMixin from '@shared/mixins/formatterMixin';

export default {
  name: 'ViewNote',
  mixins: [serviceMixin, formatterMixin],
  data() {
    return {
      logs: [],
      loading: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.note-container {
  padding: 12px;
  margin: 8px 0;
  background-color: $N5;
  border-radius: 6px;
  font-size: 14px;
  color: $N90;
}
</style>
